module.exports = __webpack_public_path__ + "static/media/1 31 dessverre.b02ad137.mp3";